import { ApolloError, useQuery } from '@apollo/client';

import { ReportSecondaryUsersListQuery, ReportSecondaryUsersListQueryVariables } from '../../types';
import { GET_REPORT_SECONDARY_USERS_LIST } from './getReportSecondaryUsersList';

export type UseGetReportSecondaryUsersList = {
  users: ReportSecondaryUsersListQuery['getReportSecondaryUsersList'];
  loading: boolean;
  error?: ApolloError;
};

const useGetReportSecondaryUsersList = (
  organizationId: string,
  adAccountIds: string[],
  excludeSellers: boolean,
  skip = false
): UseGetReportSecondaryUsersList => {
  const { data, loading, error } = useQuery<ReportSecondaryUsersListQuery, ReportSecondaryUsersListQueryVariables>(
    GET_REPORT_SECONDARY_USERS_LIST,
    {
      fetchPolicy: 'network-only',
      variables: {
        organizationId,
        adAccountIds,
        excludeSellers,
      },
      skip,
    }
  );

  return {
    users: data?.getReportSecondaryUsersList || [],
    loading,
    error,
  };
};

export default useGetReportSecondaryUsersList;
